import { motion } from "framer-motion";
import { PILLARS, IMAGES } from "@/data/content";
import { SectionHeading } from "@/components/site/primitives";

export function StudentExperience() {
  return (
    <section
      className="relative py-20 sm:py-28 text-white overflow-hidden"
      style={{ background: "linear-gradient(135deg,#0A1E4E,#071538)" }}
      data-testid="student-experience-section"
    >
      <div
        className="absolute inset-0 opacity-[0.10]"
        style={{ backgroundImage: `url(${IMAGES.graduation})`, backgroundSize: "cover", backgroundPosition: "center", filter: "blur(4px)" }}
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(135deg,rgba(10,30,78,0.92),rgba(7,21,56,0.96))" }} />
      <div className="container-x relative">
        <SectionHeading overline="The Student Experience" title="Learn. Grow. Prepare. Excel." light />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.k}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative rounded-sm border border-white/10 bg-white/5 p-7 backdrop-blur-sm"
            >
              <span className="font-mono text-sm text-[#D4AF37]">0{i + 1}</span>
              <h3 className="mt-3 font-serif text-2xl font-bold text-[#D4AF37]">{p.k}</h3>
              <p className="mt-2 text-blue-100/80 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
